import React, { type PropsWithChildren, memo } from "react";
import CollapseVariant, { type CollapseVariants } from "./Collapse.styles";

export type CollapseVariantsType = keyof typeof CollapseVariants;

type CollapseProps = {
    id?: string;
    variant: CollapseVariantsType;
};

const Collapse: React.FC<PropsWithChildren<CollapseProps>> = (props) => {
    const { variant, children, ...rest } = props;
    return (
        <CollapseVariant variant={variant} {...rest}>
            {children}
        </CollapseVariant>
    );
};

export default memo(Collapse);
